<template>
  <div id="app" class="indexpage">
    <!-- headerBar -->
    <HeaderBox
      :item="{
        homeUrl: 'index.html',
        cateUrl: 'category/'
      }"
    >
    </HeaderBox>

    <article class="mainContent">
      <!-- header -->
      <header class="headerWarp align-items-center">
        <figure class="headerLogpBox">
          <a href="./"
            ><img src="@/assets/img/header-award-logo.svg" alt=""
          /></a>
        </figure>
        <div class="headerThumbnailBox">
          <img
            src="@/../public/assets/img/award-logo-illustration.svg"
            alt=""
          />
        </div>
        <figure class="headerSubTitleBox">
          <img src="@/assets/img/resultAnnouncement.png" alt="" />
          <span
            >「今年いちばん読みたい・読んでもらいたいメルマガ」という視点から、その年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。
            今回も数多くの投票が集まりました。
            投票にご協力いただいた読者の皆様、誠にありがとうございました。</span
          >
        </figure>
      </header>

      <div class="marquee marquee-top-pc">
        <div class="marquee__inner" aria-hidden="true">
          <span
            >MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
            AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
            MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
            AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
            MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
            AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
          </span>
        </div>
      </div>
      <!-- sp header -->
      <header class="spHeaderWarp">
        <figure class="spHeaderLogpBox row align-items-center">
          <a href="./"
            ><img src="@/assets/img/header-award-logo.svg" alt=""
          /></a>
        </figure>
        <div class="spHeaderSubTitleBox vertical" style="display: flex;">
            
            <span style="letter-spacing: 0.8px; margin: 0 auto; display: block;">
              <img src="@/assets/img/spResultAnnouncement.png" class="spHeaderImg" alt="">
              
              「今年いちばん読みたい・読んでもらいたいメルマガ」という視点から、その年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。 今回も数多くの投票が集まりました。投票にご協力いただいた読者の皆様、誠にありがとうございました。</span>
            </div>
        <ul class="ankerLinkUl ankerLinkUl-middle" id="headerDownLine">
          <li class="ankerLinkLi underEyecath">
            <a href="#top5"
              ><img
                src="https://www.mag2.com/events/mag2year/2019/images/t-top5.svg"
                alt=""
              />総合大賞</a
            >
          </li>
          <li class="ankerLinkLi underEyecath">
            <a href="#new-face"
              ><img
                src="https://www.mag2.com/events/mag2year/2019/images/t-new-face.svg"
                alt=""
              />新人賞</a
            >
          </li>
          <li class="ankerLinkLi underEyecath">
            <a href="#media"
              ><img
                src="https://www.mag2.com/events/mag2year/2019/images/t-media.svg"
                alt=""
              />メディア賞</a
            >
          </li>
          <li class="ankerLinkLi underEyecath">
            <a href="#category"
              ><img
                src="https://www.mag2.com/events/mag2year/2019/images/t-top5.svg"
                alt=""
              />部門別賞</a
            >
          </li>
        </ul>

        <div class="marquee-sp">
          <div class="marquee">
            <div class="marquee__inner" aria-hidden="true">
              <span
                >MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
                AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
                MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
                AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
                MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
                AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
              </span>
            </div>
          </div>
        </div>
      </header>
      <!-- 総合大賞 -->
      <section id="top5" class="topWideColWarp">
        <div class="topWideColTitleBox box2">
          <div class="topWideColTitleBoxSubTitle">
            今年もっとも輝いたメルマガを決定する「まぐまぐ大賞」。
            ２０２０年度「いちばん読みたい・読んでもらいたいメルマガ」に輝いた総合大賞５誌を発表します。
          </div>
          <div class="topWideColTitleBoxIconAndTitle">
            <figure class="topWideColTitleBoxIcon">
              <img
                src="https://www.mag2.com/events/mag2year/2019/images/t-top5.svg"
                alt=""
              />
            </figure>
            <div class="topWideColTitleBoxTitle">総合大賞</div>
          </div>
        </div>
        <div
          class="topWideColContentBox  pcTopWideColContentBox box1"
          id="topWideColContentBox"
        >
          <div
            class="topWideColContent"
            v-for="list in sortedTop5ListByRank"
            v-bind:key="list[4]"
          >
            <WideCol
              :item="{
                no: list[0],
                categoryId: list[1],
                categoryName: list[2],
                rank: list[3],
                magazineId: list[4],
                customMagazineDescription: list[5],
                authorComment: list[6],
                userComment: list[7],
                magazineTitle: list[8],
                coverImage: list[9],
                cycleType: list[10],
                magazineIdView: list[11],
                magazineDescription: list[12],
                free: list[13],
                firstMonthPayFlag: list[14],
                basicPriceWithTax: list[15]
              }"
            >
            </WideCol>
          </div>
        </div>
        <div
          class="topWideColContentBox spTopWideColContentBox box1"
          id="topWideColContentBox"
        >
          <div
            class="topWideColContent"
            v-for="list in revSortedTop5ListByRank"
            v-bind:key="list[4]"
          >
            <SpWideCol
              :item="{
                no: list[0],
                categoryId: list[1],
                categoryName: list[2],
                rank: list[3],
                magazineId: list[4],
                customMagazineDescription: list[5],
                authorComment: list[6],
                userComment: list[7],
                magazineTitle: list[8],
                coverImage: list[9],
                cycleType: list[10],
                magazineIdView: list[11],
                magazineDescription: list[12],
                free: list[13],
                firstMonthPayFlag: list[14],
                basicPriceWithTax: list[15]
              }"
            >
            </SpWideCol>
          </div>
        </div>
      </section>
      <!-- 新人賞 -->
      <section id="new-face" class="secondSection">
        <div class="topWideColWarp">
          <div class="topWideColTitleBox box2">
            <div class="topWideColTitleBoxSubTitle">
              ２０２０年に創刊されたメルマガの中から「いちばん読みたい・読んでもらいたいメルマガ」に輝いた新人賞５誌を発表します。
            </div>
            <div class="topWideColTitleBoxIconAndTitle">
              <figure class="topWideColTitleBoxIcon">
                <img
                  src="https://www.mag2.com/events/mag2year/2019/images/t-top5.svg"
                  alt=""
                />
              </figure>
              <div class="topWideColTitleBoxTitle">新人賞</div>
            </div>
          </div>
          <div class="topWideColContentBox pcTopWideColContentBox box1">
            <div
              class="topWideColContent"
              v-for="list in sortedNewFaceListByRank"
              v-bind:key="list[4]"
            >
              <WideCol
                :item="{
                  no: list[0],
                  categoryId: list[1],
                  categoryName: list[2],
                  rank: list[3],
                  magazineId: list[4],
                  customMagazineDescription: list[5],
                  authorComment: list[6],
                  userComment: list[7],
                  magazineTitle: list[8],
                  coverImage: list[9],
                  cycleType: list[10],
                  magazineIdView: list[11],
                  magazineDescription: list[12],
                  free: list[13],
                  firstMonthPayFlag: list[14],
                  basicPriceWithTax: list[15]
                }"
              >
              </WideCol>
            </div>
          </div>
          <div
            class="topWideColContentBox spTopWideColContentBox box1"
            id="topWideColContentBox"
          >
            <div
              class="topWideColContent"
              v-for="list in revSortedNewFaceListByRank"
              v-bind:key="list[4]"
            >
              <SpWideCol
                :item="{
                  no: list[0],
                  categoryId: list[1],
                  categoryName: list[2],
                  rank: list[3],
                  magazineId: list[4],
                  customMagazineDescription: list[5],
                  authorComment: list[6],
                  userComment: list[7],
                  magazineTitle: list[8],
                  coverImage: list[9],
                  cycleType: list[10],
                  magazineIdView: list[11],
                  magazineDescription: list[12],
                  free: list[13],
                  firstMonthPayFlag: list[14],
                  basicPriceWithTax: list[15]
                }"
              >
              </SpWideCol>
            </div>
          </div>
        </div>
      </section>
      <!-- メディア賞 -->
      <section id="media" class="thaadSection">
        <div class="topnNarrowWarp">
          <div class="topnNarrowTitleBox">
            <figure class="topNarrowIcon">
              <img
                src="https://www.mag2.com/events/mag2year/2019/images/t-top5.svg"
                alt=""
              />
            </figure>
            <div class="topNarrowCateTitle color_gold">
              MEDIA<br />メディア賞
            </div>
          </div>
          <div class="topNarrowCateContent">
            <!-- news -->
            <NarrowCol
              :item="{
                list: sortedNewsListByRank,
                cateTitle: 'MAG2 NEWS賞',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-news.svg',
                mediaId: 'news'
              }"
            >
            </NarrowCol>
            <!-- money -->
            <NarrowCol
              :item="{
                list: sortedMoneyListByRank,
                cateTitle: 'MONEY VOICE賞',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-money.svg',
                mediaId: 'money'
              }"
            >
            </NarrowCol>
            <!-- tripe -->
            <NarrowCol
              :item="{
                list: sortedTripeListByRank,
                cateTitle: 'TRiP EDiTOR賞',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-tripeditor.svg',
                mediaId: 'tripeditor'
              }"
            >
            </NarrowCol>
            <!-- bythem -->
            <NarrowCol
              :item="{
                list: sortedBythemListByRank,
                cateTitle: 'by them賞',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-bythem.svg',
                mediaId: 'bythem'
              }"
            >
            </NarrowCol>
          </div>
        </div>
      </section>
      <section id="category" class="foursSection">
        <div class="topnNarrowWarp">
          <div class="topnNarrowTitleBox">
            <figure class="topNarrowIcon">
              <img
                src="https://www.mag2.com/events/mag2year/2019/images/t-section.svg"
                alt=""
              />
            </figure>
            <div class="topNarrowCateTitle color_gold">
              CATEGORY<br />部門別賞
            </div>
          </div>
          <div class="topNarrowCateContent flexWrap">
            <!-- ビジネス -->
            <NarrowCol
              :item="{
                list: sortedBusinessListByRank,
                cateTitle: 'ビジネス',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-business.svg',
                mediaId: 'business'
              }"
            >
            </NarrowCol>
            <!-- 時事解説 -->
            <NarrowCol
              :item="{
                list: sortedNewsCommentaryListByRank,
                cateTitle: '時事解説',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-news-commentary.svg',
                mediaId: 'news-commentary'
              }"
            >
            </NarrowCol>
            <!-- ジャーナリズム -->
            <NarrowCol
              :item="{
                list: sortedJournalismListByRank,
                cateTitle: 'ジャーナリズム',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-journalism.svg',
                mediaId: 'journalism'
              }"
            >
            </NarrowCol>
            <!-- 専門情報 -->
            <NarrowCol
              :item="{
                list: sortedSpecialtyListByRank,
                cateTitle: '専門情報',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-specialty.svg',
                mediaId: 'specialty'
              }"
            >
            </NarrowCol>

            <!-- 起業・経営 -->
            <NarrowCol
              :item="{
                list: sortedManagementListByRank,
                cateTitle: '起業・経営',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-management.svg',
                mediaId: 'management'
              }"
            >
            </NarrowCol>
            <!-- 資産運用（株式） -->
            <NarrowCol
              :item="{
                list: sortedAssetStockListByRank,
                cateTitle: '資産運用（株式）',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-asset-stock.svg',
                mediaId: 'asset-stock'
              }"
            >
            </NarrowCol>
            <!-- 資産運用（FX・先物・債券） -->
            <NarrowCol
              :item="{
                list: sortedAssetFxListByRank,
                cateTitle: '資産運用（FX・先物・債券）',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-asset-fx.svg',
                mediaId: 'asset-fx'
              }"
            >
            </NarrowCol>
            <!-- 資産運用（不動産・その他） -->
            <NarrowCol
              :item="{
                list: sortedAssetEsListByRank,
                cateTitle: '資産運用（不動産・その他）',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-asset-es.svg',
                mediaId: 'asset-es'
              }"
            >
            </NarrowCol>
            <!-- 政治経済 -->
            <NarrowCol
              :item="{
                list: sortedPoliticalListByRank,
                cateTitle: '政治経済',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-political.svg',
                mediaId: 'political'
              }"
            >
            </NarrowCol>
            <!-- キャリアアップ -->
            <NarrowCol
              :item="{
                list: sortedCareerListByRank,
                cateTitle: 'キャリアアップ',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-career.svg',
                mediaId: 'career'
              }"
            >
            </NarrowCol>
            <!-- 知識・ノウハウ -->
            <NarrowCol
              :item="{
                list: sortedKnowledgeListByRank,
                cateTitle: '知識・ノウハウ',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-knowledge.svg',
                mediaId: 'knowledge'
              }"
            >
            </NarrowCol>
            <!-- コラム -->
            <NarrowCol
              :item="{
                list: sortedColumnListByRank,
                cateTitle: 'コラム',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-column.svg',
                mediaId: 'column'
              }"
            >
            </NarrowCol>
            <!-- こころ -->
            <NarrowCol
              :item="{
                list: sortedPsychologyListByRank,
                cateTitle: 'こころ',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-psychology.svg',
                mediaId: 'psychology'
              }"
            >
            </NarrowCol>
            <!-- メンタルトレーニング -->
            <NarrowCol
              :item="{
                list: sortedMentalTrainingListByRank,
                cateTitle: 'メンタルトレーニング',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-mental-training.svg',
                mediaId: 'mental-training'
              }"
            >
            </NarrowCol>
            <!-- 自分磨き -->
            <NarrowCol
              :item="{
                list: sortedSelfDevelopementListByRank,
                cateTitle: '自分磨き',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-self-developement.svg',
                mediaId: 'self-developement'
              }"
            >
            </NarrowCol>
            <!-- 安全・防災 -->
            <NarrowCol
              :item="{
                list: sortedSafetyListByRank,
                cateTitle: '安全・防災',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-safety.svg',
                mediaId: 'safety'
              }"
            >
            </NarrowCol>
            <!-- 語学・資格 -->
            <NarrowCol
              :item="{
                list: sortedLanguageListByRank,
                cateTitle: '語学・資格',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-language.svg',
                mediaId: 'language'
              }"
            >
            </NarrowCol>
            <!-- 教育 -->
            <NarrowCol
              :item="{
                list: sortedEducationListByRank,
                cateTitle: '教育',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-education.svg',
                mediaId: 'education'
              }"
            >
            </NarrowCol>
            <!-- 趣味・娯楽 -->
            <NarrowCol
              :item="{
                list: sortedHobbyListByRank,
                cateTitle: '趣味・娯楽',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-hobby.svg',
                mediaId: 'hobby'
              }"
            >
            </NarrowCol>
            <!-- 生活 -->
            <NarrowCol
              :item="{
                list: sortedLifeListByRank,
                cateTitle: '生活',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-life.svg',
                mediaId: 'life'
              }"
            >
            </NarrowCol>
            <!-- 恋愛 -->
            <NarrowCol
              :item="{
                list: sortedLoveListByRank,
                cateTitle: '恋愛',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-love.svg',
                mediaId: 'love'
              }"
            >
            </NarrowCol>
            <!-- 健康 -->
            <NarrowCol
              :item="{
                list: sortedHealthListByRank,
                cateTitle: '健康',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-health.svg',
                mediaId: 'health'
              }"
            >
            </NarrowCol>
            <!-- エンタメ -->
            <NarrowCol
              :item="{
                list: sortedEntertainmentListByRank,
                cateTitle: 'エンタメ',
                src:
                  'https://www.mag2.com/events/mag2year/2019/images/t-entertainment.svg',
                mediaId: 'entertainment'
              }"
            >
            </NarrowCol>
          </div>
        </div>
      </section>

      <!-- カテゴリーボタン枠 -->
      <CategoryButtons
        :item="{
          cateUrl: 'category/'
        }"
      ></CategoryButtons>

      <!-- SNS -->
      <sns-share-buttons></sns-share-buttons>
      <!-- /SNS -->

      <!-- 歴代まぐまぐ大賞 -->
      <OldMag2Year></OldMag2Year>

      <!-- footer -->
      <IncFooter
        :item="{
          copyYear: copyYear
        }"
      ></IncFooter>
    </article>
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import axios from 'axios'
import IncFooter from '@/components/IncFooter.vue'
import SpWideCol from '@/components/SpWideCol.vue'
import OldMag2Year from '@/components/OldMag2Year.vue'
import CategoryButtons from '@/components/CategoryButtons.vue'
import HeaderBox from '@/components/HeaderBox.vue'
import WideCol from '@/components/WideCol.vue'
import NarrowCol from '@/components/NarrowCol.vue'
import SnsShareButtons from '@/components/SnsShareButtons.vue'

export default {
  name: 'App',
  components: {
    IncFooter,
    SpWideCol,
    OldMag2Year,
    CategoryButtons,
    HeaderBox,
    WideCol,
    NarrowCol,
    SnsShareButtons
  },
  data() {
    return {
      allInterviewList: [],
      top5List: [],
      revTop5List: [],
      newFaceList: [],
      revNewFaceList: [],
      newsList: [],
      moneyList: [],
      tripeList: [],
      bythemList: [],
      businessList: [],
      newsCommentaryList: [],
      journalismList: [],
      specialtyList: [],
      politicalList: [],
      managementList: [],
      careerList: [],
      assetStockList: [],
      assetFxList: [],
      assetEsList: [],
      knowledgeList: [],
      nonfictionList: [],
      psychologyList: [],
      mentalTrainingList: [],
      selfDevelopementList: [],
      safetyList: [],
      languageList: [],
      educationList: [],
      hobbyList: [],
      columnList: [],
      lifeList: [],
      loveList: [],
      healthList: [],
      entertainmentList: [],
      isMounted: false
    }
  },
  computed: {
    copyYear() {
      return new Date().getFullYear()
    },
    sortedTop5ListByRank() {
      return this.top5List.sort((a, b) => {
        return a[3] > b[3] ? -1 : a[3] < b[3] ? 1 : 0
      })
    },
    revSortedTop5ListByRank() {
      return this.revTop5List.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedNewFaceListByRank() {
      return this.newFaceList.sort((a, b) => {
        return a[3] > b[3] ? -1 : a[3] < b[3] ? 1 : 0
      })
    },
    revSortedNewFaceListByRank() {
      return this.revNewFaceList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedNewsListByRank() {
      return this.newsList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedMoneyListByRank() {
      return this.moneyList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedTripeListByRank() {
      return this.tripeList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedBythemListByRank() {
      return this.bythemList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedBusinessListByRank() {
      return this.businessList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedNewsCommentaryListByRank() {
      return this.newsCommentaryList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedJournalismListByRank() {
      return this.journalismList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedSpecialtyListByRank() {
      return this.specialtyList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedPoliticalListByRank() {
      return this.politicalList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedManagementListByRank() {
      return this.managementList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedCareerListByRank() {
      return this.careerList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedAssetStockListByRank() {
      return this.assetStockList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedAssetFxListByRank() {
      return this.assetFxList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedAssetEsListByRank() {
      return this.assetEsList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedKnowledgeListByRank() {
      return this.knowledgeList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedPsychologyListByRank() {
      return this.psychologyList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedMentalTrainingListByRank() {
      return this.mentalTrainingList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedSelfDevelopementListByRank() {
      return this.selfDevelopementList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedSafetyListByRank() {
      return this.safetyList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedLanguageListByRank() {
      return this.languageList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedEducationListByRank() {
      return this.educationList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedHobbyListByRank() {
      return this.hobbyList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedColumnListByRank() {
      return this.columnList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedLifeListByRank() {
      return this.lifeList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedLoveListByRank() {
      return this.loveList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedHealthListByRank() {
      return this.healthList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    sortedEntertainmentListByRank() {
      return this.entertainmentList.sort((a, b) => {
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    }
  },
  mounted() {
    var self = this
    self.getAwardData()
  },
  methods: {
    moveScroll: function() {
      var element = document.getElementById('topWideColContentBox')
      element.scrollLeft = 10000
    },
    zeroPadding: function(num, length) {
      return ('0000000000' + num).slice(-length)
    },
    getAwardData: function() {
      var self = this
      axios.get('assets/data/data2.json').then(function(response) {
        response.data.filter(function(item) {
          let awardDatas = item
          let magazineInfos = []
          magazineInfos.push(awardDatas.no)
          magazineInfos.push(awardDatas.categoryId)
          magazineInfos.push(awardDatas.categoryName)
          magazineInfos.push(awardDatas.rank)
          magazineInfos.push(awardDatas.magazineId)
          magazineInfos.push(awardDatas.customMagazineDescription)
          magazineInfos.push(awardDatas.authorComment)
          magazineInfos.push(awardDatas.userComment)
          magazineInfos.push(awardDatas.magazineTitle)
          magazineInfos.push(awardDatas.coverImage)
          magazineInfos.push(awardDatas.cycleType)
          magazineInfos.push(awardDatas.magazineIdView)
          magazineInfos.push(awardDatas.magazineDescription)
          magazineInfos.push(awardDatas.free)
          magazineInfos.push(awardDatas.firstMonthPayFlag)
          magazineInfos.push(awardDatas.basicPriceWithTax)
          if (awardDatas.categoryId == 'top5') {
            self.top5List.push(magazineInfos)
            self.revTop5List.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'new-face') {
            self.newFaceList.push(magazineInfos)
            self.revNewFaceList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'news') {
            self.newsList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'money') {
            self.moneyList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'tripeditor') {
            self.tripeList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'bythem') {
            self.bythemList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'business') {
            self.businessList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'news-commentary') {
            self.newsCommentaryList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'journalism') {
            self.journalismList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'specialty') {
            self.specialtyList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'political') {
            self.politicalList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'management') {
            self.managementList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'career') {
            self.careerList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'asset-stock') {
            self.assetStockList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'asset-fx') {
            self.assetFxList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'asset-es') {
            self.assetEsList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'knowledge') {
            self.knowledgeList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'psychology') {
            self.psychologyList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'mental-training') {
            self.mentalTrainingList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'self-developement') {
            self.selfDevelopementList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'safety') {
            self.safetyList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'language') {
            self.languageList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'education') {
            self.educationList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'hobby') {
            self.hobbyList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'column') {
            self.columnList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'life') {
            self.lifeList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'love') {
            self.loveList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'health') {
            self.healthList.push(magazineInfos)
          }
          if (awardDatas.categoryId == 'entertainment') {
            self.entertainmentList.push(magazineInfos)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 500px) {
  .cat-header {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .award-logo img {
    width: 60% !important;
  }
}

@media screen and (max-height: 600px) {
  .marquee-sp {
    display: none;
  }
}

@media screen and (max-width: 1000px) {
  .cat-header__award-title {
    border-style: none none solid none;
    height: 80px;
  }

  .cat-header__award-illustration {
    width: 70%;
    margin: 5px auto;
  }

  .cat-header__award-illustration img {
    height: 20vh;
  }
}

/* marquee css */
.marquee {
  position: relative;
  overflow: hidden;
  --offset: 20vw;
  --move-initial: calc(-35% + var(--offset));
  --move-final: calc(-45% + var(--offset));

  background: #222;
  color: #d4af37;
  width: 99vw;
  margin: -20px 0 20px;
  height: 60px;

  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN',
    'Hiragino Mincho Pro', HGS明朝E, メイリオ, Meiryo, serif;
}
@media all and (-ms-high-contrast: none) {
  .marquee {
    display: none;
  }
}
.marquee__inner {
  width: fit-content;
  display: flex;
  position: relative;
  transform: translate3d(var(--move-initial), 0, 0);
  animation: marquee 5s linear infinite;
  animation-play-state: running;

  width: 5000px;
  height: 50px;
}

.marquee span {
  font-size: 24px;
  /* padding: 0 2vw; */
  margin-top: 10px;
  border: solid 0.5px #d4af37;
}

.marquee-sp {
  /* position: absolute;
  bottom: -10px; */
  margin-bottom: 20px;
  margin-top: 20px;
}

@keyframes marquee {
  0% {
    transform: translate3d(var(--move-initial), 0, 0);
  }

  100% {
    transform: translate3d(var(--move-final), 0, 0);
  }
}
</style>
